import React from 'react';
import TournamentAdminList from './components/TournamentAdminList';

const TournamentsAdminPage: React.FC = () => <TournamentAdminList />;

export default TournamentsAdminPage;
